import { createAsyncThunk } from "@reduxjs/toolkit";
import { deleteRequest, getRequest, postRequest } from "../apiHelpers";
import { redisBykeyURL, redisDeleteURL, redisFlushURL, redisInfoBykeyURL, redisInfoURL, redisUpdateTTLURL } from "../pathApi";

export const callGetRedisInfo = createAsyncThunk(redisInfoURL, async () => {
    try {
        const response = await getRequest({ url: redisInfoURL });
        return response;
    } catch (error) {
        throw error;
    }
});

export const callGetRedisInfoByKey = createAsyncThunk(redisInfoBykeyURL, async (param) => {
    try {
        const response = await getRequest({ url: redisInfoBykeyURL, params: param });
        return response;
    } catch (error) {
        throw error;
    }
});

export const callGetRedisByKey = createAsyncThunk(redisBykeyURL, async (param) => {
    try {
        const response = await getRequest({ url: redisBykeyURL, params: param });
        return response;
    } catch (error) {
        throw error;
    }
});
export const callRedisDeleteByKey = createAsyncThunk(redisDeleteURL, async (param) => {
    try {
        const response = await deleteRequest({ url: redisDeleteURL, params: param });
        return response;
    } catch (error) {
        throw error;
    }
});
export const callRedisUpdateTimeByKey = createAsyncThunk(redisUpdateTTLURL, async (data) => {
    try {
        const response = await postRequest({ url: redisUpdateTTLURL, data: data });
        return response;
    } catch (error) {
        throw error;
    }
});
export const callRedisFlushDB = createAsyncThunk(redisFlushURL, async (data) => {
    try {
        const response = await postRequest({ url: redisFlushURL, data: data });
        return response;
    } catch (error) {
        throw error;
    }
});
